import React from 'react';


import { connect, useSelector } from 'react-redux';

// schemas
import { RootState } from 'redux/schemas';
import { NTimelineLectureVideo } from 'redux/schemas/models/lecture-video';
import { ActivityType } from 'redux/schemas/models/activity';
import { Video } from 'redux/schemas/models/video';
import { ComponentKeyPluralized } from 'redux/schemas/models/lecture-component';

// actions
import { setActivityExpandedInAutomatedCommunications } from 'redux/actions/course-communications';
import t from 'react-translate';

// selectors
import { getLectureVideo, getVideo, hasLectureVideoGotCommunicationError } from 'redux/selectors/timeline';
import { isActivityExpandedInAutomatedCommunications } from 'redux/selectors/course-communications';

// components
import NvIcon from 'shared/components/nv-icon';
import NvStackedTab from 'shared/components/nv-stacked-tab';

import CommunicationCreateNewDropdown from 'course_communications/components/communication-create-new-dropdown';
import CommunicationItem from 'course_communications/components/communication-item/communication-item';

type LectureVideoLectureComponentProps = {
  lectureVideoId: number
};

type StateProps = {
  lectureVideo: NTimelineLectureVideo,
  video: Video,
  hasCommunicationError: boolean,
};

const mapDispatchToProps = {
  setExpanded: setActivityExpandedInAutomatedCommunications,
};

const LectureVideoLectureComponent = (props: LectureVideoLectureComponentProps & StateProps & typeof mapDispatchToProps) => {
  const isExpanded = useSelector<RootState, boolean>((state) => isActivityExpandedInAutomatedCommunications(state, ComponentKeyPluralized.LECTURE_VIDEO, props.lectureVideoId));

  return (
    <React.Fragment>
      <div className={`lecture-component-row ${isExpanded && props.lectureVideo?.communicationsCount > 0 && 'expanded-box'}`}>
        <NvIcon icon={props.video?.type.toLocaleLowerCase()} size='smallest' />
        <div className='description'>{props.lectureVideo?.title}</div>
        <div className=''>
          <CommunicationCreateNewDropdown activityType={ActivityType.LECTURE_VIDEO} activityId={props.lectureVideoId} />
        </div>
        { props.lectureVideo?.communicationsCount > 0 && (
          <NvStackedTab
            count={props.lectureVideo.communicationsCount}
            hasError={props.hasCommunicationError}
            isExpanded={isExpanded}
            errorMessage={t.COURSE_COMMUNICATIONS.WARNINGS.ACTIVITY_COMMUNICATION()}
            onClick={() => props.setExpanded({
              type: ComponentKeyPluralized.LECTURE_VIDEO,
              id: props.lectureVideoId,
              isExpanded: !isExpanded,
            })}
          />
        )}
      </div>
      {
        // Communications
        isExpanded && props.lectureVideo?.communications && props.lectureVideo.communications.map(communicationId => (
          <CommunicationItem key={communicationId.toString()} communicationId={communicationId} />
        ))
      }
    </React.Fragment>
  );
};

const ConnectedLectureVideoLectureComponent = connect(
  (state: RootState, ownProps: LectureVideoLectureComponentProps) => ({
    lectureVideo: getLectureVideo(state, ownProps.lectureVideoId),
    video: getVideo(state, ownProps.lectureVideoId),
    hasCommunicationError: hasLectureVideoGotCommunicationError(state, ownProps.lectureVideoId),
  }),
  mapDispatchToProps,
)(LectureVideoLectureComponent);

export default ConnectedLectureVideoLectureComponent;
